import { Breakpoints, BreakpointObserver } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EndasureService } from 'src/app/services/feature/Endasure/endasure.service';

@Component({
  selector: 'app-endasure-left',
  templateUrl: './endasure-left.component.html',
  styleUrls: ['./endasure-left.component.scss'],
  standalone: false
})
export class EndasureLeftComponent {

  currentComponent: any;
  isMobile: any;
  iconToggler: boolean = true;
  private readonly destroy$ = new Subject<void>();
  constructor(private readonly endasureService: EndasureService, private readonly cdr: ChangeDetectorRef, private readonly BreakpointObserver: BreakpointObserver) {
    this.BreakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small])
      .subscribe(result => {
        this.isMobile = result.matches;

      });
  }
  SelectedComponent(componentName, event) {
    event.preventDefault();
    this.endasureService.valueDisclaimer$.pipe(takeUntil(this.destroy$)).subscribe(x=>{
      if(x){
        this.endasureService.currentComponent$.next(componentName);
      } else {
        componentName = 'visitorInfo';
      }
    })

  }
  ngOnInit() {
    this.endasureService.currentComponent$.pipe(takeUntil(this.destroy$)).subscribe(x => {
      if (x != null) {
        this.currentComponent = x;
      } else {
        this.currentComponent = 'visitorInfo';
      }
      this.cdr.detectChanges();
    })
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
